"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidUntil = void 0;
var date_fns_1 = require("date-fns");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ValidUntil = function (_a) {
    var bonus = _a.bonus;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", null,
            t('validUntil'),
            ":"),
        react_1.default.createElement("span", null, (bonus === null || bonus === void 0 ? void 0 : bonus.expireDate) &&
            (0, date_fns_1.format)(new Date(bonus.expireDate), 'dd MMM, yy, HH:mm'))));
};
exports.ValidUntil = ValidUntil;
